import { type PermittedAssetsResponse, Status2, Subscription } from '../../../src/store/facade/facadeApiV2';

export const vehiclesMock: PermittedAssetsResponse = {
    items: [
        {
            id: '733eb271-7e85-4a11-a7ce-100ba24f4e2d',
            name: '06K-58W4',
            type: 'truck',
            identification: 'WMA06KZZ1RM939405',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.Active,
                subscription: Subscription.SrpL10,
            },
            group_ids: ['8263baa2-5785-4739-929e-0e3179bd7be7'],
        },
        {
            id: '6da2b1b1-b714-4af7-9c57-c81b8dc3519a',
            name: '20H-0002 (T21) Munich',
            type: 'truck',
            identification: 'WMA20HZZ5RK002503',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.Active,
                subscription: Subscription.SrpL10,
            },
            group_ids: [
                '18ff74b4-17ab-4e0d-aba2-b8b87fd4cc39',
                '60b04b2b-da59-4a1d-a31b-90f2bac60106',
                '813facf8-4afb-4be9-904b-25fd9a48ed4f',
                '8263baa2-5785-4739-929e-0e3179bd7be7',
                '8c3eb744-e79f-4c09-b9aa-16eed6463b71',
                'a7533388-6acd-48d5-b0f7-e6234146e5e6',
                'bfac9939-bdf1-4952-8047-70daa2058705',
            ],
        },
        {
            id: 'd3ed92b5-4c95-49b9-a69e-9b2a9d840fc7',
            name: '06U-0008 (T20)',
            type: 'truck',
            identification: 'WMA06UZZ7PK002501',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.Active,
                subscription: Subscription.SrpL10,
            },
            group_ids: [
                '12fc1e72-dcce-4b36-b6de-5e89b4044264',
                '3a7e2875-4421-4df3-aa79-6905f8c3bf24',
                '60b04b2b-da59-4a1d-a31b-90f2bac60106',
                '7bdbac31-678f-4c46-ad87-950cea44d619',
                '813facf8-4afb-4be9-904b-25fd9a48ed4f',
                '8263baa2-5785-4739-929e-0e3179bd7be7',
                '84fd0625-e620-49b5-99f3-770fa4c0ca6f',
                '8c3eb744-e79f-4c09-b9aa-16eed6463b71',
                'a7533388-6acd-48d5-b0f7-e6234146e5e6',
                'bfac9939-bdf1-4952-8047-70daa2058705',
            ],
        },
        {
            id: '371eab51-88e8-4278-ab31-eb848e00cdf9',
            name: 'Gdansk 3',
            type: 'bus',
            identification: 'WMA18CZZ2PF020857',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.Inactive,
                subscription: Subscription.NoLevel,
            },
            group_ids: [],
        },
        {
            id: '6259edb8-1ad1-442d-b091-0462959c725d',
            name: '10U-0004 (T17) ',
            type: 'truck',
            identification: 'WMA10UZZ4PK002493',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.Active,
                subscription: Subscription.SrpL10,
            },
            group_ids: [
                '3a7e2875-4421-4df3-aa79-6905f8c3bf24',
                '60b04b2b-da59-4a1d-a31b-90f2bac60106',
                '7bdbac31-678f-4c46-ad87-950cea44d619',
                '813facf8-4afb-4be9-904b-25fd9a48ed4f',
                '8263baa2-5785-4739-929e-0e3179bd7be7',
                '84fd0625-e620-49b5-99f3-770fa4c0ca6f',
                'a7533388-6acd-48d5-b0f7-e6234146e5e6',
                'bfac9939-bdf1-4952-8047-70daa2058705',
            ],
        },
        {
            id: '06ece361-2022-461c-879e-666d1192133d',
            name: 'HARMAN Test CM4 09/24 #5',
            type: 'truck',
            identification: 'WMAPRTFM240909112',
            identification_type: 'vin',
            subscription_state: {
                status: Status2.PendingActivation,
                subscription: Subscription.SrpL10,
            },
            group_ids: [],
        },
    ],
};
